import React, {component} from 'react';
// import {Modal, Row, Col} from 'react-bootstrap';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Button from '../button/index';
import CloseIcon from "../../assets/icons/icon-delete.svg";
import Modal from '.';

import ButtonV2 from '../../components/button/button_v2';

import undrawAlert from '../../assets/icons/undraw-alert.svg';

import * as S from './stylesTotvs';
import { BodyM, H5 } from '../../styles/stylesTypography';

class ModalAlertTotvs extends React.Component {
    constructor(props){
        super(props);
    }

    styles = {
        control: provided => ({
            ...provided,
            padding: "15px"
        })
    };



    render(){
        const plan = localStorage.getItem("@plan_name");

        return(
            <Modal
                {...this.props}
                align='center' // center, end, start
                justify='center' // center, end, start
                responsive
            >
                <S.ModalBody marginBottom={this.props.marginBottom}>
                    <S.ContainerModalTotvs>
                        <img src={undrawAlert} alt="Alerta"/>

                        <H5>Processo não iniciado</H5>

                        <BodyM color='#303848'>
                            {plan === 'PLANO PROTHEUS' ? 'É necessário iniciar o processo através do Protheus.' : 'É necessário iniciar o processo através do seu ERP.'}
                        </BodyM>

                        <ButtonV2
                            width='215px'
                            height='48px'
                            value='Entendi'
                            outline={false}
                            onClick={() => this.props.onHide()}
                        />
                    </S.ContainerModalTotvs>
                </S.ModalBody>
            </Modal>

        );
    }
}
export default ModalAlertTotvs;
